import React, { useState } from 'react'
import { Polo, PunteggiElaborati, SquadraInSessione } from '../api/types';
import { Form, Formik, FormikHandlers, FormikHelpers } from 'formik';
import { post_bigliettini_pdf, post_bigliettini_source } from '../api';
import { Displayable, handle_drf_form_error } from 'django-rest-react';
import { ErrorBlockGeneric, FormGroupBootstrap } from '../common-components';

interface ownProps {
  all_squadre: SquadraInSessione[]
  poli: Polo[],
}

// type FormValues = Parameters<typeof post_bigliettini_pdf>[0]
interface FormValues {
  polo: number
  tipo: "tex" | "pdf"
}


const BigliettiniConsegna = ({ all_squadre, poli }: ownProps) => {
  const [error, setError] = useState<null | string>(null);
  const [pdfb64, setpdfb64] = useState<null | string>(null);
  const [latexErrorB64, setLatexErrorB64] = useState<null | string>(null);
  const [source, setSource] = useState<null | string>(null);

  return (
    <div>
      <Formik
        initialValues={{
          polo: poli[0]?.id,
          tipo: "pdf",
        }}
        enableReinitialize={true}
        onSubmit={(values: FormValues, helpers: FormikHelpers<FormValues>) => {
          const squadre_polo = all_squadre.filter(sq => sq.polo === parseInt(values.polo as unknown as string)).map(sq => sq.nome);
          const func = values.tipo === "pdf" ?
            () => post_bigliettini_pdf({ squadre: squadre_polo }).then(response => {
              if (!response.success || response.pdf_b64.length == 0) {
                setLatexErrorB64(atob(response.log_b64));
                return
              }
              setpdfb64(response.pdf_b64);
            })
            :
            () => post_bigliettini_source({ squadre: squadre_polo }).then(response => {
              setSource(response.source);
            });
          func()
            .catch(err => handle_drf_form_error(err, helpers, setError))
            .finally(() => helpers.setSubmitting(false))
        }}
      >
        {({ values, isSubmitting }) => {
          return (
            <>
              <h1>Bigliettini di consegna</h1>
              <p>La piattaforma può preparare i bigliettini di consegna pronti da essere stampati per la gara. Produrre il pdf è però computazionalmente costoso, produrre il file può richiedere anche un minuto. <span className="text-danger">Per questo, la funzionalità è disattivata durante i giorni con le gare ufficiali! Scaricate il file i giorni prima!</span></p>
              <Form>
                <FormGroupBootstrap name="polo" type="select" choices={poli} displayChoice={(polo: Polo) => polo.nome_breve} />
                <FormGroupBootstrap name="tipo" type="select" choices={[
                  { id: "tex", display: "Codice sorgente" },
                  { id: "pdf", display: "PDF" },
                ] as Displayable[]}
                  help_text={"Decidi se vuoi scaricare il PDF già pronto oppure il codice sorgente per generarlo."}
                />
                <button type="submit" className="btn btn-success" disabled={isSubmitting}>{values.tipo === "pdf" ? "Scarica" : "Renderizza"}</button>
              </Form>
              <ErrorBlockGeneric error={error} />
              {values.tipo === "pdf" && !pdfb64 && isSubmitting &&
                <p>La generazione del PDF è in corso e richiede tempo, attendi.</p>
              }
              {values.tipo === "pdf" && pdfb64 &&
                <iframe width="100%" height="500px" src={`data:application/pdf;base64,${pdfb64}`} />
              }
              {values.tipo === "pdf" && latexErrorB64 &&
                <pre className="pre-scrollable">
                  {latexErrorB64}
                </pre>
              }
              {values.tipo === "tex" && !!source &&
                <>
                  <p>Puoi compilare il seguente sorgente con <pre>lualatex</pre></p>
                  <button
                    className="btn btn-success my-2"
                    onClick={() => navigator.clipboard.writeText(source)}>
                    Copy!</button>

                  <pre className="pre-scrollable">
                    {source}
                  </pre>
                </>
              }
            </>
          )
        }}
      </Formik>
    </div >
  )
}


export default BigliettiniConsegna;
